// src/components/profiles/filters/SelfDetailsFilter.jsx
import React from 'react';
import {
  Paper,
  Typography,
  Box,
  FormControlLabel,
  Switch,
  Slider,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip
} from '@mui/material';

const SelfDetailsFilter = ({ selfDetails, onChange, options }) => {
  const handleToggle = (event) => {
    onChange({
      ...selfDetails,
      enabled: event.target.checked
    });
  };

  const handleGenderChange = (event) => {
    onChange({
      ...selfDetails,
      gender: event.target.value
    });
  };

  const handleAgeChange = (event, newValue) => {
    onChange({
      ...selfDetails,
      ageRange: newValue
    });
  };

  const handleHeightChange = (event) => {
    onChange({
      ...selfDetails,
      height: event.target.value
    });
  };

  const handleIncomeChange = (event) => {
    onChange({
      ...selfDetails,
      income: event.target.value
    });
  };

  const handleEducationChange = (event) => {
    onChange({
      ...selfDetails,
      education: event.target.value
    });
  };

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          Your Details
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={selfDetails.enabled}
              onChange={handleToggle}
              size="small"
            />
          }
          label="Enable"
        />
      </Box>

      {selfDetails.enabled && (
        <Grid container spacing={2}>
          {/* Gender */}
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Your Gender</InputLabel>
              <Select
                value={selfDetails.gender || ''}
                label="Your Gender"
                onChange={handleGenderChange}
              >
                <MenuItem value="">Select Gender</MenuItem>
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Age */}
          <Grid item xs={12}>
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Your Age: {selfDetails.ageRange[0]} - {selfDetails.ageRange[1]}
              </Typography>
              <Slider
                value={selfDetails.ageRange}
                onChange={handleAgeChange}
                valueLabelDisplay="auto"
                min={18}
                max={60}
                marks={[
                  { value: 18, label: '18' },
                  { value: 30, label: '30' },
                  { value: 45, label: '45' },
                  { value: 60, label: '60' }
                ]}
              />
            </Box>
          </Grid>

          {/* Height */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Your Height</InputLabel>
              <Select
                value={selfDetails.height || ''}
                label="Your Height"
                onChange={handleHeightChange}
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="4ft">4' - 4'11"</MenuItem>
                <MenuItem value="5ft">5' - 5'5"</MenuItem>
                <MenuItem value="5ft6">5'6" - 5'11"</MenuItem>
                <MenuItem value="6ft">6'+</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Income */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Your Income</InputLabel>
              <Select
                value={selfDetails.income || ''}
                label="Your Income"
                onChange={handleIncomeChange}
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="50000">50K PKR+</MenuItem>
                <MenuItem value="100000">100K PKR+</MenuItem>
                <MenuItem value="200000">200K PKR+</MenuItem>
                <MenuItem value="500000">500K PKR+</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Education */}
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Your Education</InputLabel>
              <Select
                value={selfDetails.education || ''}
                label="Your Education"
                onChange={handleEducationChange}
              >
                <MenuItem value="">Any</MenuItem>
                {options.education.map((edu) => (
                  <MenuItem key={edu} value={edu}>{edu}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Description */}
          <Grid item xs={12}>
            <Box sx={{ mt: 1 }}>
              <Chip
                label="Based on your details"
                size="small"
                color="info"
                variant="outlined"
              />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                These details will help us find better matches for you
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
};

export default SelfDetailsFilter;